(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl26-campaign-promo"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('cl-campaign-promo')) {
    customElements.define('cl-campaign-promo', class extends HTMLElement {
      connectedCallback() {
        this.promoController?.abort();
        this.promoController = new AbortController();
        this.querySelectorAll('img').forEach((image) => {
          const fail = () => {
            image.hidden = true;
            if (image.hasAttribute('data-promo-background')) {
              this.querySelector('.cl26-campaign-promo__art')?.setAttribute('hidden', '');
              this.classList.add('cl26-campaign-promo--text-only');
            }
          };
          image.addEventListener('error', fail, { once: true, signal: this.promoController.signal });
          if (image.complete && image.naturalWidth === 0) fail();
        });
      }
      disconnectedCallback() {
        this.promoController?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
